// extracted by mini-css-extract-plugin
export default {"testimonials_container":"testimonials_testimonials_container__YkmzQ","formCard":"testimonials_formCard__j+eyn","testimonialsCard":"testimonials_testimonialsCard__ZdBi-"};